'use strict';

const libPictView = require('pict-view');

/**
 * DashboardAccessConfig view: the shell for the #/DashboardAccess screen. Paints the header and a single #DAC-Detail
 * mount; the DashboardAccessConfig provider renders the rest. Shares the Where Records Open styles (`edc-*`).
 */
class DashboardAccessConfig extends libPictView
{
	get provider()
	{
		return this.pict.providers.DashboardAccessConfig;
	}

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading)
			{
				tmpProvider.loadAsync();
			}
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = DashboardAccessConfig;
module.exports.default_configuration =
{
	ViewIdentifier: 'DashboardAccessConfig',
	DefaultRenderable: 'DashboardAccessConfigWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.dac-dashboards { display:flex; flex-direction:column; gap:0.45rem; }
		.dac-dashboard { padding:0.45rem 0.6rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:7px; background:var(--theme-color-background-panel,#fff); }
		.dac-dashboard.is-on { border-color:var(--theme-color-border-medium,#d5dbe3); }
		.dac-landing { margin-left:0.6rem; font-size:0.8rem; }
		.dac-filters { margin:0.45rem 0 0.1rem 1.4rem; display:flex; flex-direction:column; gap:0.35rem; align-items:flex-start; }
		.dac-filter { display:flex; flex-wrap:wrap; gap:0.35rem; align-items:center; }
		.dac-filter .edc-select { min-width:8rem; }
		.dac-field, .dac-value { max-width:12rem; }
		.dac-preview-list { margin:0.2rem 0 0.4rem 1.2rem; list-style:disc; }
	`,
	Templates:
	[
		{
			Hash: 'DashboardAccessConfig-Wrap',
			Template: /*html*/`
				<div class="edc-wrap">
					<div class="edc-head">
						<h1 class="edc-title">Dashboard Access</h1>
						<p class="edc-subtitle">Choose which dashboards each role sees, the one they open first, and what data each dashboard shows them. This applies everywhere dashboards appear: LIMS, the data app, and the Fieldbook iPad app.</p>
					</div>
					<div id="DAC-Detail" class="edc-main"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'DashboardAccessConfigWrap',
			TemplateHash: 'DashboardAccessConfig-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
